import React, { useEffect, useState } from "react";
import { BooleanInput, required, SelectInput, TextInput, useRecordContext } from "react-admin";

// Hooks
import useValidators from "../../../hooks/useValidators";

// Providers
import { Organization, organizationsProvider } from "../../../providers/organizations";

export const EditControllerForm: React.FC = () => {
  const { text } = useValidators();

  const [organizations, setOrganizations] = useState<Organization[] | null>(null);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState<string | undefined>(undefined);

  const record = useRecordContext();

  const fetchData = async () => {
    const response = await organizationsProvider.getMany();
    if (response) {
      const availableLocations = response;
      setOrganizations(availableLocations);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (organizations && record && record.organization) {
      const candidate = organizations.find((organization) => organization.id === record.organization.id);
      if (candidate) {
        setSelectedOrganizationId(candidate.id);
      }
    }
  }, [organizations, record]);

  return (
    <>
      <TextInput disabled label="Id" source="id" />
      <TextInput label="Name" source="name" validate={text} />
      <TextInput label="Serial number" source="serial_number" validate={text} />
      <BooleanInput label="Active" source="is_active" />
      <SelectInput
        validate={[required()]}
        emptyText="No organization selected"
        source="organizationId"
        isPending={organizations === null}
        choices={organizations || []}
        defaultValue={selectedOrganizationId}
      />
    </>
  );
};
